export default __webpack_public_path__ + "static/sizzling-ce019e9675e69270fe07ab178fa98706.png";